import { render, staticRenderFns } from "./ModalListSit.vue?vue&type=template&id=5812346a&"
import script from "./ModalListSit.vue?vue&type=script&lang=js&"
export * from "./ModalListSit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports